import { useNavigation } from 'expo-router'
import { useCallback, useEffect } from 'react'

import FosterDetailHeaderContent from '@/components/navigation/header/FosterDetailHeaderContent'
import Page from '@/components/shared/Page'
import FosterService from '@/services/fosterService'

const headerRight = () => <FosterDetailHeaderContent />

interface Props {
  children: React.ReactNode
  scrollRef?: React.RefObject<any>
  viewId: string
  fosterId: string
}

const FosterTab = (props: Props) => {
  const navigation = useNavigation()

  const { refreshFoster } = FosterService.useFoster(props.fosterId)

  const fosterName = FosterService.useCurrentFosterName(props.fosterId)

  useEffect(() => {
    navigation.getParent()?.setOptions({
      title: fosterName || 'Add Foster',
      showSearchBar: false,
      headerRight,
    })
  }, [fosterName, navigation])

  const onRefresh = useCallback(async () => {
    await refreshFoster()
  }, [refreshFoster])

  return (
    <Page
      onRefresh={onRefresh}
      scrollRef={props.scrollRef}
      viewId={props.viewId}
    >
      {props.children}
    </Page>
  )
}

export default FosterTab
